import React, { FC } from 'react';
import { Tooltip } from '@mui/material';

interface CustomTooltipProps {
  child: JSX.Element;
  tooltipText: string | number;
}

export const CustomTooltip: FC<CustomTooltipProps> = ({ child, tooltipText }) => {
  return (
    <Tooltip title={tooltipText} className="custom-tooltip">
      {child}
    </Tooltip>
  );
};
